import {createContext, ReactNode, useEffect, useRef} from "react";

export const defaultContext: FormContextType = {
    getError(): any {
    }, getValue(): any {
    }, setError(): void {
    }, setValue(): void {
    }, async submit(): Promise<void> {
    }, touchField(): void {
    }, setTouchedField(): void {
    }, getTouchedField(): any {
    }, getRootForm(): undefined {
        return undefined
    },
    setValues(): void {
    }
}

export const FormContext = createContext<FormContextType>(defaultContext);

export default function Form(
    {children, onSubmit, initialValues, formValue, onChange}:
    { children: ReactNode, onSubmit: () => Promise<void>, initialValues?: Dictionary<any>, formValue: FormObj, onChange: (key: keyof FormObj, value: Dictionary<any> ) => void }) {

    const fieldValues = useRef<Dictionary<any>>(initialValues);

    useEffect(() => {

        fieldValues.current = formValue.fieldValues
    }, [formValue]);

    function setFieldValues(value: any) {
        onChange("fieldValues", value);
    }

    function setErrors(value: any) {
        onChange("errors", value);
    }

    function setTouchedFields(value: any) {
        onChange("touchedFields", value);
    }

    function setInitialValues(value: any) {
        onChange("initialValues", value);
    }

    useEffect(() => {
        if(initialValues !== undefined) {
            setFieldValues(initialValues);
            fieldValues.current = initialValues;
            setInitialValues(initialValues);
        }
    }, [initialValues]);

    function getValue(name: string) {
        return formValue.fieldValues[name];
    }

    function setValue(name: string, value: any) {
        setFieldValues({...fieldValues.current, [name]: value});
    }

    function setValues(values: Dictionary<any>) {
        setFieldValues({...fieldValues.current, ...values});
    }

    function getError(name: string) {
        return formValue.errors?.[name];
    }

    function setError(name: string, error: any) {
        setErrors({...formValue.errors, [name]: error});
    }

    function touchField(name: string) {
        setTouchedFields({...formValue.touchedFields, [name]: true});
    }

    function setTouchedField(name: string, value: any) {
        setTouchedFields({...formValue.touchedFields, [name]: value});
    }

    function getTouchedField(name: string) {
        return formValue.touchedFields[name];
    }

    async function submit()  {
        await onSubmit();
        return
    }
    function getRootForm() {
        return {
            getValue,
            setValue,
            getError,
            setError,
            touchField,
            setTouchedField,
            getTouchedField,
            submit,
            getRootForm,
            setValues
        }
    }



    return (
        <FormContext.Provider value={{
            getValue,
            setValue,
            setValues,
            getError,
            setError,
            touchField,
            setTouchedField,
            getTouchedField,
            submit,
            getRootForm
        }}>
            {children}
        </FormContext.Provider>
    )
}